/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';
import { formatServerDate, parseDisplayDate } from '@/util/MomentUtils';

export default async function UpdateOrderInformation(formData) {
  const response = await $.soap({
    body: {
      UpdateOrderInformation: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderID: formData.orderId,
        IsNewContract: formData.isNewContract,
        POPDate: formData.popDate ? formatServerDate(parseDisplayDate(formData.popDate)) : null,
        ReplacementPIINSPIIN: formData.replacementPIINSPIIN,
        CustomerContactedOn: formData.actualCustomerContactDate
          ? formatServerDate(parseDisplayDate(formData.actualCustomerContactDate))
          : null,
        NumReplacementDevices: formData.numReplacementDevices,
        CustomerContactDateReq: formData.requiredCustomerContactDate
          ? formatServerDate(parseDisplayDate(formData.requiredCustomerContactDate))
          : null,
        SubmissionToEPCDateReq: formData.epcSubmissionDate
          ? formatServerDate(parseDisplayDate(formData.epcSubmissionDate))
          : null,
        IsPOPUpdated: formData.popChanged,
        TrackerNumber: formData.trackerNumber
      }
    }
  });

  cleanUpResponse(response);
  return response;
}
